import styles from './Topbar.module.scss';
import SearchBar from '../SearchBar/SearchBar';

import { useDispatch, useSelector } from 'react-redux';
import { sidebarActions } from 'store/sidebar';
import { formatCurrency } from 'modules/shared/utils/common';
import { GridIcon } from 'library/icons';
import { useEffect, useRef, useState } from 'react';

const Topbar = (props) => {
    const { showSearch, searchPlaceholder, onSearch, onSearcFocus } = props;

    const dispatch = useDispatch();

    const billing = useSelector((state) => state.billing);
    const { user, token } = useSelector((state) => state.auth);

    const pulseAppUrl = `${process.env.REACT_APP_PULSE_AUTHORIZE_URL}?token=${token}`;

    const [showDropdown, setShowDropdown] = useState(false);

    const menuRef = useRef();
    const dropdownRef = useRef();

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                menuRef.current &&
                !menuRef.current.contains(event.target) &&
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target)
            ) {
                setShowDropdown(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const toggleSidebar = () => {
        dispatch(sidebarActions.show());
    };

    return (
        <div className={styles.topbar}>
            <div className={styles.topbarContent}>
                {showSearch && <SearchBar placeholder={searchPlaceholder} onSearch={onSearch} onFocus={onSearcFocus} />}

                <div className={`${styles.topNav} relative`}>
                    {user.permissions.account && (
                        <div className={styles.usageWrapper}>
                            <div className={styles.usageLabel}>USAGE</div>
                            <div className={styles.usageValue}>{formatCurrency(billing.amount, billing.currency)}</div>
                        </div>
                    )}
                    {/* <div ref={menuRef}>
                        <GridIcon
                            onClick={() => {
                                setShowDropdown(!showDropdown);
                            }}
                            className="mr-4 cursor-pointer"
                        />
                    </div> */}
                    {showDropdown && (
                        <ul
                            ref={dropdownRef}
                            className="absolute right-20 top-14 text-base shadow rounded-md bg-white p-2  !pl-0"
                        >
                            <>
                                <li
                                    onClick={() => {
                                        window.open(pulseAppUrl, '_blank');
                                        setShowDropdown(false);
                                    }}
                                    className="flex items-center gap-x-3 text-black cursor-pointer hover:bg-gray-200 px-4 py-2 rounded-md"
                                >
                                    <img className="w-5 h-5" src="/images/progress_center_logo.svg" alt="" />
                                    <span>Pulse</span>
                                </li>
                                <li
                                    onClick={() => {
                                        setShowDropdown(false);
                                    }}
                                    className="flex items-center gap-x-3 text-black cursor-pointer hover:bg-gray-200 px-4 py-2 rounded-md"
                                >
                                    <img className="w-5 h-5" src="/images/logo.svg" alt="" />
                                    <span>Quantam</span>
                                </li>
                            </>
                        </ul>
                    )}

                    <div className={styles.avatar}>
                        <img src="/images/default_avatar.png" alt="" />
                    </div>

                    <button className={styles.menuToggler} onClick={toggleSidebar}>
                        <i className="fa fa-bars"></i>
                    </button>
                </div>
            </div>
        </div>
    );
};

Topbar.defaultProps = {
    showSearch: true,
};

export default Topbar;
